import {
  FETCH_SUBSCRIPTION_HISTORY_REQUEST,
  FETCH_SUBSCRIPTION_HISTORY_SUCCESS,
  FETCH_SUBSCRIPTION_HISTORY_FAILURE,
} from '../../constants/ActionTypes';

const subscriptionHistory = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_HISTORY_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_SUBSCRIPTION_HISTORY_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_SUBSCRIPTION_HISTORY_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

export default subscriptionHistory;
